<template>
  <div>
    <template v-if="pattern=='model'">
      必填
      <Checkbox label="必填" v-model="content.must"></Checkbox>
      <Input style="width:100px" v-model="content.title" :disabled="$route.name!='approvalCreate'" placeholder="请输入标题"></Input>
    </template>
      <div style="display: inline-block;width:100px;text-align: right;vertical-align: top;" v-else>{{content.title}}<span style="color: red" v-if="content.must">*</span></div>
    ：
    <template v-if="pattern=='model'">
      <RadioGroup :disabled="true" v-model="content.selected" style="max-width:350px">
        <template v-for="(item,index) in content.label">
          <Poptip title="修改选项" trigger="hover">
            <Radio :disabled="true" :label="item"></Radio>
            <Row slot="content" type="flex" align="middle">
              <Col span="20"><Input v-model="content.label[index]"></Input></Col>
              <Col span="4"><Icon class="close-icon" type="md-close-circle" @click="content.label.splice(index,1)"></Icon></Col>
            </Row>
          </Poptip>
        </template>
      </RadioGroup>
      <Icon class="close-icon" style="color:#19be6b" type="md-add-circle" @click="content.label.push('单选文字')"></Icon>
      <Icon class="close-icon" type="md-close-circle" @click="$emit('del',index)"></Icon>
    </template>
    <template v-else>
      <!-- <RadioGroup :disabled="pattern!='submission'" v-model="content.selected" style="max-width:350px"> -->
      <RadioGroup v-if="pattern=='submission'" v-model="content.selected" style="max-width:350px">
        <template v-for="(item,index) in content.label">
          <!-- <Radio :disabled="pattern!='submission'" :label="item"></Radio> -->
          <Radio :label="item"></Radio>
        </template>
      </RadioGroup>
      <span v-else>{{content.selected}}</span>
    </template>
  </div>
</template>

<script>
  export default {
    name: "approvalRadio",//单项选择器
    props:{
      index:Number,
      pattern:String,
      contentIn:Object,
    },
    data:function () {
      return{
        content:{
          title:'',
          selected:'',
          label:[],
          must:false,
          allowSubmission:false,
        },
      }
    },
    mounted:function () {
      if(this.contentIn.title!=undefined){
        this.content = this.contentIn
      }
    },
    watch:{
      content:{
        handler(){
          if(this.content.must!=true||!this.isEmpty(this.content.selected)){
            this.content.allowSubmission = true
          }else{
            this.content.allowSubmission = false
          }
          this.$emit('change',this.content)
        },
        deep:true,
        immediate:true,
      }
    }
  }
</script>

<style scoped>

</style>